import React from 'react';
import styled from 'styled-components';

import 'antd/lib/checkbox/style/index.css';

import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import TreeSelect from 'components/ui/TreeSelect';
import CtaCard from 'components/ui/CtaCard';

import { colors } from 'helpers/ColorHelper';
import { titleize } from 'helpers/Formatter';

import { getTranslatedString } from 'helpers/i18n';

const StyledTitle = styled.span`
  font-size: 18px;
  font-family: 'Circular-Bold';
`;

const StyledFilterContainer = styled.div`
  margin-bottom: 8px;
`;

export const StyledLink = styled(CtaCard)`
  flex-grow: 1;
  padding: 0;
  color: ${colors.PURE_BLUE};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 14px;
  text-align: right;
  float: right;
`;

const Filters = ({ filterOptions, onCheckFilter, filterSelected, filtersEmpty }) => {
  return filterOptions.map((filter, index) => {
    return (
      <StyledFilterContainer>
        <Row>
          <Col span={12}>
            <StyledTitle>
              {titleize(
                getTranslatedString(`landlordPortal.multiselectAdvanced.${filter.title_key}`)
              )}
            </StyledTitle>
          </Col>
          <Col span={12}>
            {index === 0 && filtersEmpty === false && (
              <StyledLink onClick={() => onCheckFilter([])} type="button">
                {getTranslatedString('landlordPortal.filterAndSelect.clearFilters')}
              </StyledLink>
            )}
          </Col>
        </Row>
        <TreeSelect
          onCheck={(selected) => onCheckFilter(selected, index)}
          checkedKeys={filterSelected[index]}
          treeData={filter.children}
        />
      </StyledFilterContainer>
    );
  });
};

export default Filters;
